import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import { TrackingConstant } from 'client/tracking/constant';
import { CATEGORIES, FALLBACK_CATEGORY } from 'client/site-modules/shared/utils/inventory/features-and-specs';

import './feature-item.scss';

export function FeatureItem({ features = [], id, name, summaryHeadingTag: SummaryHeadingTag = 'h3' }) {
  const icon = get(
    CATEGORIES.find(({ title }) => title === name),
    'icon',
    ''
  );
  const [isItemOpened, setIsItemOpened] = useState(name === FALLBACK_CATEGORY);

  const handleToggle = useCallback(
    event => {
      setIsItemOpened(!isItemOpened);
      event.preventDefault();
    },
    [isItemOpened]
  );

  return (
    <Row className="feature-item mx-0 px-0 py-1 c-pointer feature-item-modular">
      <details open={isItemOpened} className="w-100">
        <summary
          className="d-flex justify-content-between"
          data-tracking-id="vdp_view_content"
          data-subaction-name={TrackingConstant.VIEW_FEATURES}
          data-tracking-value={name}
          onClick={handleToggle}
          data-no-refresh
        >
          <SummaryHeadingTag className="feature-title fw-bold m-0 size-16">
            <i className={classnames('text-gray-darker me-1', icon)} aria-hidden />
            {name}
          </SummaryHeadingTag>
          <i
            className={classnames('medium text-primary-darker', {
              'icon-arrow-down4': !isItemOpened,
              'icon-arrow-up4': isItemOpened,
            })}
            aria-hidden
          />
        </summary>
        <ul id={id} className="mx-0 mb-0 mt-0_25 ps-2">
          {features.map(({ optionText }) => (
            <li key={optionText} className="mt-0_75">
              {optionText}
            </li>
          ))}
        </ul>
      </details>
    </Row>
  );
}

FeatureItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      optionText: PropTypes.string,
    })
  ),
  summaryHeadingTag: PropTypes.string,
};
